import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { GetLatestUpdate } from '../../../redux/services/upnApi';

const LatestUpdate = ({ isUpnLoaded }: { isUpnLoaded: boolean }): React.ReactElement => {
  const { token } = useSelector((state: RootState) => state.auth);
  const [latestUpdate, setLatestUpdate] = useState<Date | null>(null);

  useEffect(() => {
    if (isUpnLoaded) {
      GetLatestUpdate(token).then((res: Date) => {
        const a = new Date(res);
        const utc = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds());
        setLatestUpdate(new Date(utc));
      }).catch((err) => {
        console.error(err);
      });
    } else {
      setLatestUpdate(null);
    }
  }, [isUpnLoaded]);

  if (!latestUpdate) {
    return <></>;
  }

  return (
    <><label>Last Cache Update: {latestUpdate.toLocaleString()}</label></>
  );
};

export default LatestUpdate;
